import { compose as x } from "../../tailwind-buddy-interface.js";
import { headingStyles as s } from "../../mixins/typography.js";
const e = x({
  slots: {
    root: ""
  },
  variants: {
    /** Sets the heading size. */
    size: {
      inherit: "",
      xxxl: s.xxxl,
      xxl: s.xxl,
      xl: s.xl,
      lg: s.lg,
      md: s.md,
      sm: s.sm,
      xs: s.xs,
      xxs: s.xxs
    }
  },
  defaultVariants: {
    size: "md"
  },
  responsiveVariants: ["size"]
})();
export {
  e as headingVariants
};
